export var RenderCapable;
(function (RenderCapable) {
    RenderCapable[RenderCapable["Element_Index_Uint32"] = 0] = "Element_Index_Uint32";
    RenderCapable[RenderCapable["Element_Index_Uint8"] = 1] = "Element_Index_Uint8";
    RenderCapable[RenderCapable["TextureFormat_R32G32B32A32"] = 2] = "TextureFormat_R32G32B32A32";
    RenderCapable[RenderCapable["TextureFormat_R16G16B16A16"] = 3] = "TextureFormat_R16G16B16A16";
    RenderCapable[RenderCapable["Texture_anisotropic"] = 4] = "Texture_anisotropic";
    RenderCapable[RenderCapable["RenderTextureFormat_R16G16B16A16"] = 5] = "RenderTextureFormat_R16G16B16A16";
    RenderCapable[RenderCapable["RenderTextureFormat_R32G32B32A32"] = 6] = "RenderTextureFormat_R32G32B32A32";
    RenderCapable[RenderCapable["RenderTextureFormat_Depth"] = 7] = "RenderTextureFormat_Depth";
    RenderCapable[RenderCapable["RenderTextureFormat_ShadowMap"] = 8] = "RenderTextureFormat_ShadowMap";
    RenderCapable[RenderCapable["Vertex_VAO"] = 9] = "Vertex_VAO";
    RenderCapable[RenderCapable["DrawElement_Instance"] = 10] = "DrawElement_Instance";
    RenderCapable[RenderCapable["Shader_TextureLod"] = 11] = "Shader_TextureLod";
    RenderCapable[RenderCapable["COMPRESS_TEXTURE_S3TC"] = 12] = "COMPRESS_TEXTURE_S3TC";
    RenderCapable[RenderCapable["COMPRESS_TEXTURE_S3TC_SRGB"] = 13] = "COMPRESS_TEXTURE_S3TC_SRGB";
    RenderCapable[RenderCapable["COMPRESS_TEXTURE_PVRTC"] = 14] = "COMPRESS_TEXTURE_PVRTC";
    RenderCapable[RenderCapable["COMPRESS_TEXTURE_ETC1"] = 15] = "COMPRESS_TEXTURE_ETC1";
    RenderCapable[RenderCapable["COMPRESS_TEXTURE_ETC"] = 16] = "COMPRESS_TEXTURE_ETC";
    RenderCapable[RenderCapable["COMPRESS_TEXTURE_ASTC"] = 17] = "COMPRESS_TEXTURE_ASTC";
    RenderCapable[RenderCapable["Texture_SRGB"] = 18] = "Texture_SRGB";
    RenderCapable[RenderCapable["MSAA"] = 19] = "MSAA";
    RenderCapable[RenderCapable["UnifromBufferObject"] = 20] = "UnifromBufferObject";
    RenderCapable[RenderCapable["Texture3D"] = 21] = "Texture3D";
    RenderCapable[RenderCapable["Texture_FloatLinearFiltering"] = 22] = "Texture_FloatLinearFiltering";
    RenderCapable[RenderCapable["Texture_HalfFloatLinearFiltering"] = 23] = "Texture_HalfFloatLinearFiltering";
    RenderCapable[RenderCapable["StorageBuffer"] = 24] = "StorageBuffer";
    RenderCapable[RenderCapable["ComputeShader"] = 25] = "ComputeShader";
    RenderCapable[RenderCapable["IndirectDraw"] = 26] = "IndirectDraw";
})(RenderCapable || (RenderCapable = {}));
